export const cx = (...values: Array<string | false | null | undefined>): string =>
  values.filter(Boolean).join(' ');

export const focusRingClass = 'so-focus-ring';

export const interactiveClass = 'so-interactive';

export const fieldControlClass =
  'so-focus-ring so-interactive min-h-control-comfortable w-full rounded-control border border-border-strong bg-surface px-3 text-body text-ink placeholder:text-ink-muted hover:border-ink-muted disabled:cursor-not-allowed disabled:bg-surface-recessed disabled:text-ink-muted aria-invalid:border-status-invalid';
